<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <!-- <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList"
        >
          <el-option
            v-for="item in courseCategoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select> -->
      </div>
      <div class="r">
        <el-button
          type="primary"
          @click="()=> dialogVisible = true"
        >
          新建课程类型
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <course-category-dialog
      :dialog-visible.sync="dialogVisible"
      :item="courseCategoryItem"
      @confirm="getList"
      @close="()=> courseCategoryItem = {}"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { courseCategoryList } from '@/config';
import courseCategoryDialog from '@/components/common/courseCategoryDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    courseCategoryDialog,
  },
  data() {
    return {
      courseCategoryList,
      dialogVisible: false,
      searchForm: {
        valid: '',
        pageNum: 1,
        pageSize: 10,
      },
      tabelData: {},
      courseCategoryItem: {},
      tableColumn: [
        {
          key: 'categoryName',
          label: '类型名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'categoryDesc',
          label: '类型说明',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'valid',
          label: '状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.COURSE_CATEGORY_ENABLE]: '启用', [types.COURSE_CATEGORY_DISABLE]: '禁用', successKey: types.COURSE_CATEGORY_ENABLE },
          render: () => 'status',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'mpIconUrl',
          label: 'ICON显示图片',
          width: '120px',
          dataType: 'component',
          render: () => 'image',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.COURSE_CATEGORY_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.COURSE_CATEGORY_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList() {
      const result = await axClient.course.getPageCategory(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 禁用/启用/删除
    confirmDialog(item, deleteValid) {
      this.$confirm('确定禁用/启用/删除该课程分类？', '禁用/启用/删除课程分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        let { valid } = item;
        if (deleteValid) {
          valid = deleteValid;
        } else {
          valid = valid === types.COURSE_CATEGORY_ENABLE
            ? types.COURSE_CATEGORY_DISABLE : types.INDENTITY_VALID_ENABLE;
        }
        const data = await axClient.course.updateCategoryValid(
          {
            id,
            valid,
          },
        );
        if (data) {
          this.$message.success('启用/禁用/删除课程分类成功');
          this.getList();
        }
      });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      console.log(item);
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.courseCategoryItem = item;
          this.dialogVisible = true;
          break;
        case 2:
          this.deletedItem(item);
          break;
        default:
          break;
      }
    },
    // 删除
    deletedItem(item) {
      this.$confirm('确定删除该课程类型？', '删除课程类型', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { id } = item;
        const data = await axClient.course.updateCategoryValid(
          {
            id,
            valid: 30,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getList();
        }
      });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        courseRegistrationCount: {
          ascending: 10,
          descending: 20,
        },
        createTime: {
          ascending: 30,
          descending: 40,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // 处理省市区
    formatCity(item) {
      const [provinceId, cityId, areaId] = item;
      this.searchForm = Object.assign(this.searchForm, { provinceId, cityId, areaId });
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
      }
    }
    .r {
      display: flex;
      align-items: center;
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
    }
  }
}
</style>
